import moment from "moment";
import { boolean, object, string } from "yup";

export const enrollmentsNewValidations = object({
  firstName: string().min(1).max(25).required("First name is required").min(2),
  lastName: string().required("Last name is required").min(2),
  email: string()
    .required("Email is required")
    .email("Invalid email")
    .test("pattern", "Email is not valid", (value) => {
      return Boolean(
        value &&
        /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.((?!con$)[a-zA-Z0-9]{2,12})$/.exec(
          value
        )
      );
    }),

  phone: string()
    .required("Phone number is required")
    .length(10, "Phone number must be 10 digits"),
  address: string().required("Address is required"),
  unit: string().optional(),
  moveInDate: string()
    .required("Move in date is required")
    .test(
      "move-in-date",
      "Tenant must be at least 18 years old on move-in date",
      function (value) {
        if (!this.parent.dob && this.parent.ssn) return true;
        const dobValidDate = moment(this.parent.dob).add(18, "years");
        return moment(value).isSameOrAfter(dobValidDate);
      }
    )
    .test(
      "move-in-date-in-past",
      "Move in date must be in the past",
      function (value) {
        return moment(value).isSameOrBefore(moment());
      }
    ),
  leaseEndDate: string()
    .test(
      "optional-if-month-to-month",
      "Lease end date is required",
      function (value) {
        return this.parent.isMonthToMonth || value;
      }
    )
    .test(
      "lease-1-month",
      "Lease must be at least one calendar month long.",
      function (value) {
        const firstValidDate = moment(this.parent.moveInDate).add(1, "month");
        return (
          this.parent.isMonthToMonth ||
          moment(value).isSameOrAfter(firstValidDate)
        );
      }
    )
    .test(
      "ongoing-lease",
      "Lease end date must be in the the future",
      function (value) {
        return (
          this.parent.isMonthToMonth ||
          moment(value).isSameOrAfter(moment().subtract(1, "day"))
        );
      }
    ),
  isMonthToMonth: boolean(),
  currentRentAmount: string().required("Rent amount is required"),
  ssn: string()
    .test("ssn_length", "SSN must be 9 digits", function (value) {
      const nonDigitsRegex = /\D/g;
      if (!value) return true;
      return value.replaceAll(nonDigitsRegex, "").length === 9;
    })
    .test("ssn-or-dob", "SSN or Date of Birth is required", function (value) {
      return this.parent.dob || value;
    }),
  dob: string()
    .test("dob", "Invalid date of birth", function (value) {
      return value ? moment(value).isValid() : true;
    })
    .test(
      "must_be_18_years_old",
      "Must be at least 18 years old",
      function (value) {
        if (!value) return true;
        return moment().diff(moment(value), "years") >= 18;
      }
    )
    .test("ssn-or-dob", "SSN or Date of Birth is required", function (value) {
      return this.parent.ssn || value;
    })
});
